import { render, staticRenderFns } from "./ImportacaoConfiguracao.vue?vue&type=template&id=444486fa"
import script from "./ImportacaoConfiguracao.vue?vue&type=script&lang=js"
export * from "./ImportacaoConfiguracao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports